module.exports = __webpack_public_path__ + "static/media/stripe-logo.64f7c20b.svg";